import { useState } from "react";
import { api } from "@/lib/api";
import Layout from "@/components/Layout";
import Header from "@/components/Header";
import BusinessCard from "@/components/BusinessCard";
import { Spinner, EmptyState } from "@/components/States";
import { Navigation, MapPin } from "lucide-react";
import { motion } from "framer-motion";

export default function NearbyPage() {
  const [items, setItems] = useState([]);
  const [status, setStatus] = useState("idle"); // idle | locating | loading | done | error
  const [error, setError] = useState("");

  const findNearby = () => {
    if (!navigator.geolocation) {
      setError("Tu dispositivo no permite geolocalización.");
      setStatus("error");
      return;
    }
    setStatus("locating");
    navigator.geolocation.getCurrentPosition(
      (pos) => {
        setStatus("loading");
        api
          .get("/businesses", { params: { lat: pos.coords.latitude, lng: pos.coords.longitude } })
          .then((r) => {
            setItems(r.data);
            setStatus("done");
          })
          .catch(() => {
            setError("No pudimos cargar los negocios.");
            setStatus("error");
          });
      },
      () => {
        setError("Necesitamos permiso de ubicación para mostrarte negocios cercanos.");
        setStatus("error");
      },
      { enableHighAccuracy: true, timeout: 10000 }
    );
  };

  return (
    <Layout>
      <Header subtitle="Negocios cerca de ti" />
      <section className="px-5 pt-4">
        <h2 className="font-display text-3xl font-black tracking-tighter">Cerca de mí</h2>
        <p className="mt-1 text-sm text-[#5C5C5C]">Usa tu ubicación para descubrir lo más cercano.</p>

        {(status === "idle" || status === "error") && (
          <motion.button
            whileTap={{ scale: 0.97 }}
            onClick={findNearby}
            data-testid="find-nearby-button"
            className="mt-6 flex w-full items-center justify-center gap-2 rounded-2xl bg-[#E54D2E] py-4 font-bold text-white shadow-lg shadow-[#E54D2E]/25"
          >
            <Navigation size={18} strokeWidth={2.4} />
            Buscar negocios cercanos
          </motion.button>
        )}
        {status === "error" && (
          <p className="mt-3 flex items-center gap-1.5 text-sm font-semibold text-[#E54D2E]" data-testid="nearby-error">
            <MapPin size={14} /> {error}
          </p>
        )}
      </section>

      {(status === "locating" || status === "loading") && <Spinner />}

      {status === "done" &&
        (items.length === 0 ? (
          <EmptyState title="No encontramos negocios cercanos" subtitle="Amplía tu búsqueda por categoría." />
        ) : (
          <section className="flex flex-col gap-4 px-5 pt-6">
            <p className="text-xs font-bold uppercase tracking-[0.2em] text-[#1A1A1A]">
              Ordenados por cercanía
            </p>
            {items.map((b, i) => (
              <BusinessCard key={b.id} business={b} index={i} />
            ))}
          </section>
        ))}
    </Layout>
  );
}
